import { Transition } from "@headlessui/react";
import { Trans, useTranslation } from "react-i18next";
import { DeviceFC } from "types";

import { RoamingGlobeIcon } from "@/assets/icons/icons";
import { ExtendedSimCardDetail } from "@/hooks/useExtendedSims";
import { getFirstOfSortedRoaming, isZone1 } from "@/utils/deviceUtils";

export const RoamingUsage: DeviceFC = ({
  device,
}: {
  device: ExtendedSimCardDetail;
}) => {
  // We want only the most important of maximum three roaming infos displayed here.
  const roamingInfo = getFirstOfSortedRoaming(device);
  const hasRoaming = (roamingInfo?.initialVolume || 0) > 0;
  const { t } = useTranslation();

  // Zone 1 displays in GB, Zone 2/3 display in MB
  const useGB = isZone1(roamingInfo?.usageZone);
  const spent =
    (roamingInfo?.initialVolume || 0) - (roamingInfo?.remainingVolume || 0);
  const available = roamingInfo?.initialVolume || 0;

  return (
    <Transition
      className="mb-4 flex flex-row items-center gap-3 whitespace-nowrap text-base"
      appear
      show={hasRoaming}
      enter="ease-out duration-300"
      enterFrom="opacity-0 scale-95"
      enterTo="opacity-100 scale-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100 scale-100"
      leaveTo="opacity-0 scale-95"
    >
      <RoamingGlobeIcon role="img" title={t("translation:Icons.roaming")} />

      <Trans
        t={t}
        components={[<span key={0} className="font-semibold"></span>]}
        values={{
          spent: useGB
            ? parseFloat((spent / 1000).toFixed(2)).toString()
            : spent,
          available: useGB
            ? parseFloat((available / 1000).toFixed(2)).toString()
            : available,
        }}
        i18nKey={
          useGB
            ? "layout.tiles.activeSim.roamingUsageGB"
            : "layout.tiles.activeSim.roamingUsage"
        }
      />
    </Transition>
  );
};
